module.exports = __webpack_public_path__ + "static/media/mmm-clock-home.b816c8ba.svg";